import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { QuestionObj } from 'src/types/quiz';
import quizStore from '../store/QuizStore';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

interface ImproveQuestionDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  improvementObjs: ImprovementObj[];
}

export interface ImprovementObj {
  question: QuestionObj;
  improvements: string | null;
  questions: QuestionObj[];
}

const ImproveQuestionDialog: React.FC<ImproveQuestionDialogProps> = ({
  open,
  setOpen,
  improvementObjs,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const currentImprovement = improvementObjs[currentIndex];

  const handleSelectQuestion = async (newQuestion: QuestionObj) => {
    await quizStore.updateQuestion(
      currentImprovement.question.id,
      newQuestion.question,
      newQuestion.answer,
    );
    if (currentIndex < improvementObjs.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      setOpen(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>
            Improvement Question {currentIndex + 1} of {improvementObjs.length}
          </DialogTitle>
          {currentImprovement.improvements && (
            <DialogDescription>
              {currentImprovement.improvements}
            </DialogDescription>
          )}
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <Button
            key={0}
            variant="outline"
            className="p-4 h-auto text-left flex flex-col items-start w-full whitespace-normal break-words"
            onClick={() => handleSelectQuestion(currentImprovement.question)}
          >
            <div className="font-semibold break-words w-full">
              <span className="font-bold">Original Question:</span>{' '}
              {currentImprovement.question.question}
            </div>
            <div className="text-sm text-muted-foreground break-words w-full">
              <span className="font-bold">Answer:</span>{' '}
              {currentImprovement.question.answer}
            </div>
          </Button>
          {currentImprovement.questions.map((q, index) => (
            <Button
              key={index}
              variant="outline"
              className="p-4 h-auto text-left flex flex-col items-start w-full whitespace-normal break-words"
              onClick={() => handleSelectQuestion(q)}
            >
              <div className="font-semibold break-words w-full">
                {q.question}
              </div>
              <div className="text-sm text-muted-foreground break-words w-full">
                Answer: {q.answer}
              </div>
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default observer(ImproveQuestionDialog);
